
import { FicheArticle } from '@/model/fiche-article';
import { RouteName } from '@/router/routes';
import Vue from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
  name: 'CarouselArticles',
  props: {
    hideArticles: {
      type: Array as () => number[],
      default: () => [] as number[]
    }
  },
  data: () => ({
    carouselValue: 0
  }),
  computed: {
    ...mapGetters({ articles: 'article/listeArticle', tiers: 'tiers/infosTiers' }),

    articlesSorted (): FicheArticle[] {
      return (this.articles as FicheArticle[])
        .slice()
        .filter(a => !this.hideArticles.includes(a.article.id));
    }
  },
  methods: {
    gotoPageArticle (idArticle: any) {
      this.$router.push({ name: RouteName.MAIN_DETAIL, params: { idArticle } });
    }
  }
});
